import './Blog.css';

const Blog = () => {
    return (
        <div className="blog-page">
            <div className="blog-container">
                <h1>Blog</h1>
                <p>Discover the latest news and stories from Renz Foods.</p>
            </div>
        </div>
    );
};

export default Blog;